import cc from 'classcat';
import { Button, TextArea } from '..';
import { useTranslation } from '../../../hooks/useTranslation';

interface IYesNo {
    title: string;
    className?: string;
    description?: string;
    onYes: () => void;
    onNo: () => void;
    onYesText: string;
    onNoText: string;
    updateReason: string;
    setUpdateReason: (value: string) => void;
    placeholder?: string;
}

export const YesNoModalWithReason = (props: IYesNo) => {
    const { t } = useTranslation('evaluations');
    return (
        <div className={cc(['yes-no-with-reason', props.className])}>
            <img className="yes-no-with-reason__close-button" src="/svg/x-button.svg" onClick={props.onNo} alt="Close"></img>
            <div className="yes-no-with-reason__title-container">
                <h3 className="yes-no-with-reason__title">{props.title}</h3>
                {props.description && <p className={'yes-no-with-reason__description'}>{props.description}</p>}
            </div>
            <TextArea
                className="yes-no-with-reason__textarea"
                id="updateReason"
                value={props.updateReason}
                onChange={e => {
                    props.setUpdateReason(e.target.value);
                }}
                label={t('updateReason')}
                placeholder={props.placeholder}
            />
            <div className="yes-no-with-reason__buttons">
                <Button onClick={props.onNo} text={props.onNoText} variant={'text'} color="blue" />
                <Button text={props.onYesText} onClick={props.onYes} variant={'contained'} />
            </div>
        </div>
    );
};
